import serverInterface from 'server-interface';

import {
  applyTraits
} from 'utilities/javascript';

import DataManagerTraits from '../traits';

class MetricsManager {

  constructor(application) {

    this.initialized = false;
    this.collection = [];

    this.application = application;

  }

  handleCreatedEvent(payload) {

    this.tryAdd(payload.collection);

  }

  registerEventHandlers() {}

  async loadAll() {

    this.collection = await serverInterface.startup.metrics.getAllSystemMetrics();

  }

  async create(payload) {

    let item = await serverInterface.startup.metrics.createSystemMetric(payload);

    this.tryAdd(item);

    return item;

  }

  async initialize(bootstrapData) {

    this.registerEventHandlers();

    this.collection = bootstrapData.systemMetrics;

    this.initialized = true;

  }

}

export default applyTraits(MetricsManager, [DataManagerTraits]);